import React from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import { createBrowserHistory } from "history";
import PrivateRoute from './PrivateRoute'

import AuthDialog from '../components/Login/AuthDialog'
import UpdateProfile from '../components/Login/UpdateProfile'
import BulkPopUp from '../components/Widget/BulkPopUp'

import NavigationBar from '../components/Nav/NavigationBar'
import SimpleNav from '../components/Nav/SimpleNav'
import App from '../components/App'
import Page from '../components/Menu/Page'
import ProfileInfo from '../components/Profile/ProfileInfo'
import AddressBook from '../components/Profile/AddressBook'
import LiveOrders from '../components/Order/LiveOrders'
import PastOrders from '../components/Order/PastOrders'
import CheckOut from '../components/Order/CheckOut'
import Footer from '../components/Footer/Footer'

// extra pages
import About from '../components/Extra/About'
import Privacy from '../components/Extra/Privacy'
import Terms from '../components/Extra/Terms'
import Refund from '../components/Extra/Refund'
import NotFound from '../components/Extra/NotFound'

export const history = createBrowserHistory();

export default () => {
    return (
        <Router history={history}>
            <AuthDialog />
            <UpdateProfile />
            <BulkPopUp />
            <Switch>
                <Route path="/" exact render={routeProps => (
                    <>
                        <NavigationBar  {...routeProps} />
                        <App />
                    </>
                )} />

                <Route path="/menu/:id" exact render={routeProps => (
                    <>
                        <NavigationBar {...routeProps} />
                        <Page {...routeProps} />
                    </>
                )} />
                <PrivateRoute path="/profile" component={ProfileInfo} exact />
                <PrivateRoute path="/address-book" component={AddressBook} exact />
                <PrivateRoute path="/live-orders" component={LiveOrders} exact />
                <PrivateRoute path="/past-orders" component={PastOrders} exact />
                <PrivateRoute path="/checkout" component={CheckOut} exact />

                <Route path="/about" exact render={routeProps => (
                    <>
                        <SimpleNav />
                        <About {...routeProps} />
                    </>
                )} />
                <Route path="/privacy" exact render={routeProps => (
                    <>
                        <SimpleNav />
                        <Privacy {...routeProps} />
                    </>
                )} />
                <Route path="/terms" exact render={routeProps => (
                    <>
                        <SimpleNav />
                        <Terms {...routeProps} />
                    </>
                )} />
                <Route path="/refund" exact render={routeProps => (
                    <>
                        <SimpleNav />
                        <Refund {...routeProps} />
                    </>
                )} />

                <Route render={routeProps => (
                    <>
                        <SimpleNav />
                        <NotFound {...routeProps} />
                    </>
                )} />
            </Switch>
            <Footer />
        </Router >
    )
}